import {useTranslation} from "@i18n/client";
import React, {useState} from "react";
import useBiosConstants from "src/constants/BiosConstants";
import useMediaQuery from "src/useMediaQuery";

import Modal from "../Modal";
import BioCard from "./BioCard";
import Profile from "./Profile";
import SectionHeader from "./SectionHeader";

const Bios: React.VoidFunctionComponent = () => {
  const i18n = useTranslation();
  const {bios} = useBiosConstants();
  // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'number | (() => number)'.
  const [activeIndex, setActiveIndex] = useState<number>(null);
  const [shouldAutoFocus, setShouldAutoFocus] = useState(true);

  const toggleActiveIndex = (index?: number) => () => {
    if (Number.isInteger(index)) {
      setShouldAutoFocus(true);
    } else {
      setShouldAutoFocus(false);
    }
    // @ts-expect-error TS2345: Argument of type 'number | null | undefined' is not assignable to parameter of type 'SetStateAction<number>'.
    setActiveIndex(Number.isInteger(index) ? index : null);
  };

  const setActiveProfile = {
    none: toggleActiveIndex(),
    next: toggleActiveIndex(activeIndex + 1 > bios.length - 1 ? 0 : activeIndex + 1),
    prev: toggleActiveIndex(activeIndex - 1 < 0 ? bios.length - 1 : activeIndex - 1),
  };

  const closingFocusRef = bios[activeIndex]?.ref;

  const isSm = useMediaQuery("sm");

  const closeButtonStyle = isSm && {
    top: 80,
    backgroundColor: "white",
  };

  return (
    <div id="our-leaders" className="ph8 pt24 pt20-sm pb10 ph4-xs">
      <div className="maxw80 ma">
        <div className="mb15 mb6-sm">
          <SectionHeader tag={i18n.t("Who we are")} header={i18n.t("Our leaders")} />
        </div>
        <div className="df dg-xs af fw gg2-xs" style={{"--w": "140px"}}>
          {bios
            .sortBy(({order}) => order)
            .map((person, i) => (
              <BioCard
                ref={person.ref}
                key={person.name}
                person={person}
                index={i}
                toggleActiveIndex={toggleActiveIndex}
              />
            ))}
        </div>
      </div>
      <Modal
        aria-modal
        className="br3-f w100vw-sm h100vh-sm br0-f-sm df-sm pt10-sm jcc-sm"
        innerClasses="p0-f-sm"
        active={Number.isInteger(activeIndex)}
        // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'number | undefined'.
        onClickOutside={toggleActiveIndex(null)}
        shouldAutoFocus={shouldAutoFocus}
        closeFocusRef={closingFocusRef}
        closeButtonStyle={closeButtonStyle}
      >
        <Profile
          total={bios.length}
          person={bios.sortBy(({order}) => order)[activeIndex]}
          activeIndex={activeIndex}
          setActiveProfile={setActiveProfile}
          closingFocusRef={closingFocusRef}
        />
      </Modal>
    </div>
  );
};

export default Bios;
